export const environment = {
  production: false,
  loaderOnHttp: true,
  version: '1.0.0',

  // Where onboarding hands off once setup completes — the application, not this
  // site. redirectToApp() runs after terminateSession(), so pointing it here
  // returns a signed-out user to the flow they just finished.
  appURL: 'https://core-dev.lab.avyna.io',

  coreApi: {
    host: 'https://core-api-dev.lab.avyna.io',
  },
};
